import React from 'react';
import { connect } from 'react-redux';
import LoadingStatusModal from './LoadingStatusModal';

const LITE_DASHBOARD_PATH_PREFIX = '/lite/dashboard';
const LITE_DESIGN_PATH_PREFIX = '/project/lite/design';

interface Props {
  exposureRecalculation: boolean;
  pathname: string;
}

class ExposureRecalculationModal extends React.Component<Props> {
  private shouldSuppress(): boolean {
    const { pathname } = this.props;
    const path = pathname || '';

    if (path.indexOf(LITE_DASHBOARD_PATH_PREFIX) === 0) {
      return true;
    }

    if (path.indexOf(LITE_DESIGN_PATH_PREFIX) === 0) {
      if (typeof document === 'undefined') {
        return false;
      }
      const satelliteActive = document.querySelector('.v3-canvas-container.view-satellite');
      if (!satelliteActive) {
        return true;
      }
    }

    return false;
  }

  render() {
    const visible = this.props.exposureRecalculation && !this.shouldSuppress();

    return (
      <LoadingStatusModal
        id="exposure-recalculation"
        visible={visible}
        title="Exposure recalculation"
        message="Recalculating panel exposure for the current design."
        hint="Ensures array exposure values are aligned before proceeding to the Part List or Engineering pages."      />
    );
  }
}

const mapStateToProps = (appState: appState) => ({
  exposureRecalculation: appState.panels.exposureRecalculation,
  pathname: (appState.router && appState.router.location && appState.router.location.pathname) || '',
});

export default connect(mapStateToProps)(ExposureRecalculationModal);

